/**
 * @file ProductCardLine.tsx
 * @description Строка «Карточка: «Классика» · бейдж, фасовка, кнопка
 * текстом — одна на весь сайт [Изменить карточку →]» в панели элемента
 * «Товары» (phase19.16 Р2а; uiux-design-r2a §4): карточка товара настраивается
 * один раз в «Сайт → Каталог → Карточка товара». Переход — через выбор
 * конструктора: несохранённый блок спросит «Сохранить / Не сохранять».
 * Вне конструктора (тесты) — только текст.
 * SB120 этап 3б (TD-436): у «Товаров» это единственная строка-переход —
 * карточка и её шрифт и цвет в Каталоге (отдельной строки нет, ревью).
 */

import { readCatalogOptions } from "@chaiberi/shared";
import { useContext } from "react";

import { BuilderContext } from "../../builder-context";
import { SiteViewContext } from "../../../site-view/site-view-context";
import { cardSummary } from "../../../../lib/site-view/catalog-form";
import { CATALOG_CARD_SELECTION } from "../../../../lib/site-builder/panels";

export function ProductCardLine() {
  const b = useContext(BuilderContext);
  const raw = useContext(SiteViewContext)?.parts?.catalog.fields.options;
  const options = readCatalogOptions(raw ?? {}).options;
  return (
    <p className="type-caption flex flex-wrap items-center gap-x-2 rounded-lg bg-surface-low px-3 py-2 text-on-surface-variant">
      <span>Карточка: {cardSummary(options)} — одна на весь сайт, её шрифт и цвет — там же.</span>
      {b ? (
        <button
          type="button"
          className="inline-flex min-h-12 items-center font-medium text-primary hover:underline"
          onClick={() => void b.select(CATALOG_CARD_SELECTION)}
        >
          Карточка, шрифт и цвет — в Каталоге →
        </button>
      ) : null}
    </p>
  );
}
